<!-- =========================================================================================
    File Name: UserSubscriptionPopup.vue
    Description: User Subscription details
========================================================================================== -->
<template>
<div>
  <vs-popup :title="$t('SUBSCRIPTION_INFORMATION')" :active.sync="isSubPopupActiveLocal">
    <vs-list>
      <vs-list-header icon-pack="feather" icon="icon-bell" :title="$t('SUBSCRIPTION_INFORMATION')"></vs-list-header>

      <vs-list-item :title="$t('USER_ID')" >
        {{userInfo.user.userId}}
      </vs-list-item>

      <vs-list-item :title="$t('SUBSCRIPTION_YN')" >
        <vs-chip :color="getInAppBillingStatusColor(userInfo.subscription.inAppBillingStatus)">
          {{$t(setInAppBillingStatusName(userInfo.subscription.inAppBillingStatus))}}
        </vs-chip>
      </vs-list-item>

      <vs-list-item :title="$t('SUBSCRIPTION_CODE')" >
        <vs-chip :color="getSubscriptionCodeColor(userInfo.subscription.subscriptionCode)">
          {{$t(setSubscriptionCodeName(userInfo.subscription.subscriptionCode))}}
        </vs-chip>
      </vs-list-item>
      
      <vs-list-item :title="$t('LAST_BILLING_DATE')" >
          {{setLastBillingDate(userInfo.subscription.lastBillingDate)}}
      </vs-list-item>

      <vs-list-item :title="$t('USED_STORAGE')" :subtitle="$t('STORAGE_QUOTA')+` : ${userInfo.subscription.storageQuota.toLocaleString()}MB`">
        <p class="float-right"> {{userInfo.subscription.usedStorage.toLocaleString()}}MB / {{userInfo.subscription.storageQuota.toLocaleString()}}MB </p>
        <p> {{storagePercent}} % </p>
        <vs-progress class="subscription-progress" :percent="storagePercent" :color="getProgressColor(storagePercent)"></vs-progress>  
      </vs-list-item>

      <vs-list-item :title="$t('USED_STREAMING_TIME')"  :subtitle="$t('STREAMING_QUOTA_TIME')+` : ${userInfo.subscription.streamingQuotaTime}`+$t('MINUTE')" >
        <p class="float-right"> {{userInfo.subscription.usedStreamingTime}}{{$t('MINUTE')}} / {{userInfo.subscription.streamingQuotaTime}}{{$t('MINUTE')}} </p>
        <p> {{streamingPercent}} % </p>
        <vs-progress class="subscription-progress" :percent="streamingPercent" :color="getProgressColor(streamingPercent)"></vs-progress>
      </vs-list-item>

      <vs-list-item :title="$t('UPLOAD_USED_TRAFFIC')" :subtitle="$t('UPLOAD_TRAFFIC_QUOTA')+` : ${userInfo.subscription.uploadTrafficQuota.toLocaleString()}MB`">
        <p class="float-right"> {{userInfo.subscription.uploadUsedTraffic.toLocaleString()}}MB / {{userInfo.subscription.uploadTrafficQuota.toLocaleString()}}MB </p>
        <p> {{uploadDataTrafficPercent}} % </p>
        <vs-progress class="subscription-progress" :percent="uploadDataTrafficPercent" :color="getProgressColor(uploadDataTrafficPercent)"></vs-progress>
      </vs-list-item>

      <vs-list-item :title="$t('DOWNLOAD_USED_TRAFFIC')" :subtitle="$t('DOWNLOAD_TRAFFIC_QUOTA')+` : ${userInfo.subscription.downloadTrafficQuota.toLocaleString()}MB`">
        <p class="float-right"> {{userInfo.subscription.downloadUsedTraffic.toLocaleString()}}MB / {{userInfo.subscription.downloadTrafficQuota.toLocaleString()}}MB </p>
        <p> {{downloadDataTrafficPercent}} % </p>
        <vs-progress class="subscription-progress" :percent="downloadDataTrafficPercent" :color="getProgressColor(downloadDataTrafficPercent)"></vs-progress>
      </vs-list-item>
    </vs-list>

    <vs-divider/>

    <div class="float-right">
      <vs-button type="border" color="danger" @click.stop="isSubPopupActiveLocal = false">{{$t('CLOSE')}}</vs-button>
    </div>
  </vs-popup>
</div>
</template>



<script>

export default {
  data() {
    return {
    }
  },
  props: {
    isSubPopupActive: {
      type: Boolean,
      required: true
    },
  },
  computed: {
    userInfo(){
      return this.$store.state.dataUser.userInfo
    },
    storagePercent(){
      return this.getPercentage(this.$store.state.dataUser.userInfo.subscription.usedStorage, this.$store.state.dataUser.userInfo.subscription.storageQuota)
    },
    streamingPercent(){
      return this.getPercentage(this.$store.state.dataUser.userInfo.subscription.usedStreamingTime, this.$store.state.dataUser.userInfo.subscription.streamingQuotaTime)
    },
    uploadDataTrafficPercent(){
      return this.getPercentage(this.$store.state.dataUser.userInfo.subscription.uploadUsedTraffic, this.$store.state.dataUser.userInfo.subscription.uploadTrafficQuota)
    },
    downloadDataTrafficPercent(){
      return this.getPercentage(this.$store.state.dataUser.userInfo.subscription.downloadUsedTraffic, this.$store.state.dataUser.userInfo.subscription.downloadTrafficQuota)
    },
    isSubPopupActiveLocal: {
      get() {
        return this.isSubPopupActive
      },
      set(val) {
        if (!val) {
          this.$emit('close')
        }
      }
    },
  },
  methods: {
    getInAppBillingStatusColor(status) {
      if (status === "") return "primary"
      return this.$store.state.commonConfig.inAppBillingStatus.properties[status].color
    },
    setInAppBillingStatusName(status){
      if (status === "") return ""
      return this.$store.state.commonConfig.inAppBillingStatus.properties[status].name
    },
    getSubscriptionCodeColor(status) {
      if (status === "") return "primary"
      return this.$store.state.commonConfig.subscriptionCode.properties[status].color
    },
    setSubscriptionCodeName(status){
      if (status === "") return ""
      return this.$store.state.commonConfig.subscriptionCode.properties[status].name
    },
    setLastBillingDate(date){
      if (!date) {
        return '-'
      }
      else {
        return date.substr(0,4)+"-"+date.substr(4,2)+"-"+date.substr(6,2)
      }
    },
    getPercentage(used, quota){
      if (used === 0) return 0
      if (quota === 0) return 0
      else return Math.round((used/quota)*100)
    },
    getProgressColor(percentage){
      if (percentage >= 80) return "danger"
      if (percentage >= 50) return "warning"
      if (percentage >= 0) return "success"
      else return "primary"
    },
  }
}

</script>

<style scoped>

.subscription-progress{
  width: 250px;
}
</style>